<script lang="ts" setup></script>

<template>
  <svg
    id="Zakladniprvky_Sipka_Drobeckovka"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="7"
    viewBox="0 0 17 7"
  >
    <path
      id="Path_53"
      data-name="Path 53"
      d="M6772,796.728h16"
      transform="translate(-6772 -793.228)"
      fill="none"
      stroke="#000"
      stroke-width="1"
    />
    <path
      id="Polygon_1"
      data-name="Polygon 1"
      d="M3.5,0,7,4H0Z"
      transform="translate(17) rotate(90)"
    />
  </svg>
</template>
